<!-- <div class="min-h-screen bg-gradient-to-br from-purple-50 via-blue-50 to-indigo-100 dark:from-slate-900 dark:via-purple-900/20 dark:to-slate-900 p-6"> -->

@if (!mixedMode()) {
<div class="mb-8">
  <div class="mb-6">
    <div class="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4">
      <div class="flex-1">
        <h1 class="text-4xl font-medium text-[#141437] dark:text-white">
          Lendee Analytics Dashboard
        </h1>
      </div>
      <div class="flex flex-wrap items-center gap-3">
        <div
          class="flex items-center gap-2 bg-purple-100/50 dark:bg-purple-900/30 px-4 py-2 rounded-xl border border-purple-200/50 dark:border-purple-700/50">
          <app-icon name="chartLine" [size]="16" class="text-purple-600 dark:text-purple-400"></app-icon>
          <span class="text-sm font-medium text-purple-700 dark:text-purple-300">Live Data</span>
        </div>
        <button type="button" (click)="openCustomizeLayout()"
          class="flex items-center gap-1.5 px-3 py-2 rounded-xl border border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-800 text-slate-700 dark:text-slate-200 text-sm font-medium hover:border-[#AD46FF]/60 hover:text-[#AD46FF] transition-all duration-200 shadow-sm whitespace-nowrap">
          <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <rect width="7" height="7" x="3" y="3" rx="1" />
            <rect width="7" height="7" x="14" y="3" rx="1" />
            <rect width="7" height="7" x="14" y="14" rx="1" />
            <rect width="7" height="7" x="3" y="14" rx="1" />
          </svg>
          Customize layout
        </button>
      </div>
    </div>
  </div>
  <div class="relative z-[99] mb-4">
    <app-date-picker [allowComparison]="false" [showComparison]="false" [showGroupBy]="false"
      placeholder="Select date range" variant="outline" size="md" (dateRangeChange)="onDateRangeChange($event)"
      class="inline-block">
    </app-date-picker>
  </div>
</div>
}

<ng-template #sectionPin let-sectionId>
  @if (!mixedMode()) {
  <button type="button" (click)="addToCustomDashboard(sectionId); $event.stopPropagation()"
    [disabled]="isAddingToCustomDashboard(sectionId)"
    class="group/pin absolute cursor-pointer top-2 right-2 z-20 inline-flex items-center gap-1.5 h-7 px-2.5 rounded-full border shadow-sm text-[11px] font-medium whitespace-nowrap opacity-0 translate-y-[-2px] group-hover:opacity-100 group-hover:translate-y-0 focus-visible:opacity-100 focus-visible:translate-y-0 transition-all duration-200 disabled:cursor-default"
    [ngClass]="isAddedToCustomDashboard(sectionId)
          ? 'bg-emerald-50 text-emerald-700 border-emerald-200 dark:bg-emerald-900/30 dark:text-emerald-300 !opacity-100 !translate-y-0'
          : 'bg-white/95 text-[#AD46FF] border-[#AD46FF]/30 hover:bg-violet-50 dark:bg-slate-800/95 dark:border-purple-500/40'"
    [title]="isAddedToCustomDashboard(sectionId) ? 'Remove from My Custom Dashboard' : 'Add to My Custom Dashboard'">
    @if (isAddingToCustomDashboard(sectionId)) {
    <svg class="animate-spin shrink-0" xmlns="http://www.w3.org/2000/svg" width="11" height="11" viewBox="0 0 24 24"
      fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
      <path d="M21 12a9 9 0 1 1-6.219-8.56" />
    </svg>
    <span>{{ isAddedToCustomDashboard(sectionId) ? 'Removing' : 'Adding' }}&hellip;</span>
    } @else if (isAddedToCustomDashboard(sectionId)) {
    <!-- Pinned state: compact green check at rest so the card title
             stays fully visible. Hovering morphs the pill open and flips
             the affordance to a remove minus + label. -->
    <svg class="shrink-0 block group-hover/pin:hidden" xmlns="http://www.w3.org/2000/svg" width="11" height="11"
      viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.8" stroke-linecap="round"
      stroke-linejoin="round">
      <path d="M20 6 9 17l-5-5" />
    </svg>
    <svg class="shrink-0 hidden group-hover/pin:block" xmlns="http://www.w3.org/2000/svg" width="11" height="11"
      viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.8" stroke-linecap="round"
      stroke-linejoin="round">
      <path d="M5 12h14" />
    </svg>
    <span
      class="inline-block max-w-0 -ml-1.5 group-hover/pin:max-w-[220px] group-hover/pin:ml-0 focus-visible:max-w-[220px] focus-visible:ml-0 overflow-hidden whitespace-nowrap transition-all duration-300 ease-out">Remove
      from Custom Dashboard</span>
    } @else {
    <!-- Not-pinned state: pill hidden at card-rest. On card hover it
             fades in as a compact "+" icon. Hovering the icon then morphs
             the pill open to reveal the label, so the card title is never
             obscured at rest. -->
    <svg class="shrink-0" xmlns="http://www.w3.org/2000/svg" width="11" height="11" viewBox="0 0 24 24" fill="none"
      stroke="currentColor" stroke-width="2.8" stroke-linecap="round" stroke-linejoin="round">
      <path d="M5 12h14" />
      <path d="M12 5v14" />
    </svg>
    <span
      class="inline-block max-w-0 -ml-1.5 group-hover/pin:max-w-[200px] group-hover/pin:ml-0 focus-visible:max-w-[200px] focus-visible:ml-0 overflow-hidden whitespace-nowrap transition-all duration-300 ease-out">Pin
      to Custom Dashboard</span>
    }
  </button>
  }
</ng-template>

<div [class]="mixedMode() ? 'unified-tile-body h-full' : ''">
  <div class="grid grid-cols-12 gap-6 grid-flow-row-dense items-stretch" [class.gap-0]="mixedMode()"
    [class.h-full]="mixedMode()">

    @for (sec of embeddedVisibleSections(); track trackSection($index, sec)) {
    @switch (sec.id) {
    @case (SectionId.REQUESTS_CARD) {
    <div [ngClass]="[sectionCardShellClass(), getSectionColClass(SectionId.REQUESTS_CARD)]">
      <ng-container *ngTemplateOutlet="sectionPin; context: { $implicit: SectionId.REQUESTS_CARD }"></ng-container>
      <div class="flex items-center gap-4 mb-6">
        <div
          class="w-14 h-14 bg-gradient-to-br from-purple-500 to-indigo-500 rounded-xl flex items-center justify-center shadow-lg">
          <app-icon name="clipboard" [size]="28" class="text-white"></app-icon>
        </div>
        <div class="flex-1">
          <h3 class="text-xl font-medium text-[#141437] dark:text-white">Requests</h3>
          <p class="text-sm text-slate-500 dark:text-slate-400">Complete loan application pipeline</p>
        </div>
      </div>

      <!-- Main Total -->
      <div
        class="mb-6 p-4 bg-gradient-to-r from-purple-50 to-indigo-50 dark:from-purple-900/20 dark:to-indigo-900/20 rounded-xl border border-purple-200/50 dark:border-purple-700/50">
        <div class="text-center">
          <p class="text-sm font-medium text-purple-700 dark:text-purple-300 mb-1">Total Applications</p>
          <span class="text-4xl font-bold text-purple-600 dark:text-purple-400">
            {{ stats().requests.total_requests || 0 | number }}
          </span>
        </div>
      </div>

      <div class="flex-1 flex flex-col">
        <!-- Request Types -->
        <div class="mb-6">
          <p class="text-sm font-medium text-slate-600 dark:text-slate-300 mb-3 flex items-center gap-2">
            <app-icon name="user" [size]="16"></app-icon>
            Request Types
          </p>
          <div class="space-y-2">
            <div
              class="flex justify-between items-center bg-green-50 dark:bg-green-900/20 px-3 py-2.5 rounded-lg border border-green-200 dark:border-green-800">
              <span class="text-sm font-medium text-green-700 dark:text-green-300">Public Requests</span>
              <span class="font-bold text-green-800 dark:text-green-200">{{ stats().requests.public_requests || 0 |
                number }}</span>
            </div>
            <div
              class="flex justify-between items-center bg-blue-50 dark:bg-blue-900/20 px-3 py-2.5 rounded-lg border border-blue-200 dark:border-blue-800">
              <span class="text-sm font-medium text-blue-700 dark:text-blue-300">Private Requests</span>
              <span class="font-bold text-blue-800 dark:text-blue-200">{{ stats().requests.private_requests || 0 |
                number }}</span>
            </div>
          </div>
        </div>

        <!-- Request Status -->
        <div>
          <p class="text-sm font-medium text-slate-600 dark:text-slate-300 mb-3 flex items-center gap-2">
            <app-icon name="circleAlert" [size]="16"></app-icon>
            Request Status
          </p>
          <div class="space-y-2">
            <div
              class="flex justify-between items-center bg-red-50 dark:bg-red-900/20 px-3 py-2 rounded-lg border border-red-200 dark:border-red-800">
              <span class="text-xs font-medium text-red-700 dark:text-red-300">Cancelled</span>
              <span class="font-semibold text-red-800 dark:text-red-200">{{ stats().requests.cancelled_requests || 0 |
                number }}</span>
            </div>
            <div
              class="flex justify-between items-center bg-orange-50 dark:bg-orange-900/20 px-3 py-2 rounded-lg border border-orange-200 dark:border-orange-800">
              <span class="text-xs font-medium text-orange-700 dark:text-orange-300">Expired</span>
              <span class="font-semibold text-orange-800 dark:text-orange-200">{{ stats().requests.expired_requests || 0
                | number }}</span>
            </div>
            <div
              class="flex justify-between items-center bg-amber-50 dark:bg-amber-900/20 px-3 py-2 rounded-lg border border-amber-200 dark:border-amber-800">
              <span class="text-xs font-medium text-amber-700 dark:text-amber-300">Cancelled After Offer</span>
              <span class="font-semibold text-amber-800 dark:text-amber-200">{{
                stats().requests.cancelled_requests_after_offer || 0 | number }}</span>
            </div>
          </div>
        </div>
      </div>
      @if(isLoading()){
      <app-individual-toaster></app-individual-toaster>
      }
    </div>
    }

    @case (SectionId.OFFERS_CARD) {
    <div [ngClass]="[sectionCardShellClass(), getSectionColClass(SectionId.OFFERS_CARD)]">
      <ng-container *ngTemplateOutlet="sectionPin; context: { $implicit: SectionId.OFFERS_CARD }"></ng-container>
      <div class="flex items-center gap-4 mb-6">
        <div
          class="w-14 h-14 bg-gradient-to-br from-pink-500 to-rose-500 rounded-xl flex items-center justify-center shadow-lg">
          <app-icon name="user" [size]="28" class="text-white"></app-icon>
        </div>
        <div class="flex-1">
          <h3 class="text-xl font-medium text-[#141437] dark:text-white">Offers</h3>
          <p class="text-sm text-slate-500 dark:text-slate-400">Loan offers and responses</p>
        </div>
      </div>

      <!-- Main Total -->
      <div
        class="mb-6 p-4 bg-gradient-to-r from-pink-50 to-rose-50 dark:from-pink-900/20 dark:to-rose-900/20 rounded-xl border border-pink-200/50 dark:border-pink-700/50">
        <div class="text-center">
          <p class="text-sm font-medium text-pink-700 dark:text-pink-300 mb-1">Total Offers Made</p>
          <span class="text-4xl font-bold text-pink-600 dark:text-pink-400">
            {{ stats().offers.total_offers || 0 | number }}
          </span>
        </div>
      </div>

      <div class="flex-1 flex flex-col">
        <!-- Offer Responses -->
        <div class="mb-6">
          <p class="text-sm font-medium text-slate-600 dark:text-slate-300 mb-3 flex items-center gap-2">
            <app-icon name="check" [size]="16"></app-icon>
            Offer Responses
          </p>
          <div class="space-y-2">
            <div
              class="flex justify-between items-center bg-green-50 dark:bg-green-900/20 px-3 py-2.5 rounded-lg border border-green-200 dark:border-green-800">
              <span class="text-sm font-medium text-green-700 dark:text-green-300">Accepted</span>
              <span class="font-bold text-green-800 dark:text-green-200">{{ stats().offers.offers_accepted || 0 | number
                }}</span>
            </div>
            <div
              class="flex justify-between items-center bg-amber-50 dark:bg-amber-900/20 px-3 py-2.5 rounded-lg border border-amber-200 dark:border-amber-800">
              <span class="text-sm font-medium text-amber-700 dark:text-amber-300">Pending Response</span>
              <span class="font-bold text-amber-800 dark:text-amber-200">{{ stats().offers.offers_pending || 0 | number
                }}</span>
            </div>
          </div>
        </div>

        <!-- Offer Issues -->
        <div>
          <p class="text-sm font-medium text-slate-600 dark:text-slate-300 mb-3 flex items-center gap-2">
            <app-icon name="x" [size]="16"></app-icon>
            Offer Issues
          </p>
          <div class="space-y-2">
            <div
              class="flex justify-between items-center bg-red-50 dark:bg-red-900/20 px-3 py-2 rounded-lg border border-red-200 dark:border-red-800">
              <span class="text-xs font-medium text-red-700 dark:text-red-300">Cancelled Offers</span>
              <span class="font-semibold text-red-800 dark:text-red-200">{{ stats().offers.cancelled_offers || 0 |
                number }}</span>
            </div>
            <div
              class="flex justify-between items-center bg-orange-50 dark:bg-orange-900/20 px-3 py-2 rounded-lg border border-orange-200 dark:border-orange-800">
              <span class="text-xs font-medium text-orange-700 dark:text-orange-300">Lacks Funds</span>
              <span class="font-semibold text-orange-800 dark:text-orange-200">{{ stats().offers.lacks_funds || 0 |
                number }}</span>
            </div>
            <div
              class="flex justify-between items-center bg-purple-50 dark:bg-purple-900/20 px-3 py-2 rounded-lg border border-purple-200 dark:border-purple-800">
              <span class="text-xs font-medium text-purple-700 dark:text-purple-300">Cancelled by Supporter</span>
              <span class="font-semibold text-purple-800 dark:text-purple-200">{{ stats().offers.cancelled_by_supporter
                || 0 | number }}</span>
            </div>
          </div>
        </div>
      </div>
      @if(isLoading()){
      <app-individual-toaster></app-individual-toaster>
      }
    </div>
    }

    @case (SectionId.PAYMENT_PLANS_CARD) {
    <div [ngClass]="[sectionCardShellClass(), getSectionColClass(SectionId.PAYMENT_PLANS_CARD)]">
      <ng-container *ngTemplateOutlet="sectionPin; context: { $implicit: SectionId.PAYMENT_PLANS_CARD }"></ng-container>
      <div class="flex items-center gap-4 mb-6">
        <div
          class="w-14 h-14 bg-gradient-to-br from-blue-500 to-cyan-500 rounded-xl flex items-center justify-center shadow-lg">
          <app-icon name="layoutDashboard" [size]="28" class="text-white"></app-icon>
        </div>
        <div class="flex-1">
          <h3 class="text-xl font-medium text-[#141437] dark:text-white">Payment Plans</h3>
          <p class="text-sm text-slate-500 dark:text-slate-400">Repayment schedule management</p>
        </div>
      </div>

      <!-- Main Total -->
      <div
        class="mb-6 p-4 bg-gradient-to-r from-blue-50 to-cyan-50 dark:from-blue-900/20 dark:to-cyan-900/20 rounded-xl border border-blue-200/50 dark:border-blue-700/50">
        <div class="text-center">
          <p class="text-sm font-medium text-blue-700 dark:text-blue-300 mb-1">Plans Created</p>
          <span class="text-4xl font-bold text-blue-600 dark:text-blue-400">
            {{ stats().paymentPlans.plans_created || 0 | number }}
          </span>
        </div>
      </div>

      <div class="flex-1 flex flex-col">
        <!-- Today's Activity -->
        <div class="mb-6">
          <p class="text-sm font-medium text-slate-600 dark:text-slate-300 mb-3 flex items-center gap-2">
            <app-icon name="calendar" [size]="16"></app-icon>
            Today's Activity
          </p>
          <div class="space-y-2">
            <div
              class="flex justify-between items-center bg-green-50 dark:bg-green-900/20 px-3 py-2.5 rounded-lg border border-green-200 dark:border-green-800">
              <span class="text-sm font-medium text-green-700 dark:text-green-300">Completed Today</span>
              <span class="font-bold text-green-800 dark:text-green-200">{{ stats().paymentPlans.plans_completed_today
                || 0 | number }}</span>
            </div>
            <div
              class="flex justify-between items-center bg-red-50 dark:bg-red-900/20 px-3 py-2.5 rounded-lg border border-red-200 dark:border-red-800">
              <span class="text-sm font-medium text-red-700 dark:text-red-300">Overdue Today</span>
              <span class="font-bold text-red-800 dark:text-red-200">{{ stats().paymentPlans.plans_overdue_today || 0 |
                number }}</span>
            </div>
          </div>
        </div>

        <!-- Overdue Summary -->
        <div class="mt-auto">
          <p class="text-sm font-medium text-slate-600 dark:text-slate-300 mb-3 flex items-center gap-2">
            <app-icon name="triangleAlert" [size]="16"></app-icon>
            Overdue Summary
          </p>
          <div class="space-y-2">
            <div
              class="flex justify-between items-center bg-red-50 dark:bg-red-900/20 px-3 py-2.5 rounded-lg border border-red-200 dark:border-red-800">
              <span class="text-sm font-medium text-red-700 dark:text-red-300">Total Overdue Plans</span>
              <span class="font-bold text-red-800 dark:text-red-200">{{ stats().paymentPlans.plans_overdue_total || 0 |
                number }}</span>
            </div>
            <div class="flex justify-center mt-3">
              <div
                class="text-xs text-slate-500 dark:text-slate-400 bg-slate-100 dark:bg-slate-700 px-3 py-1 rounded-full">
                {{ ((stats().paymentPlans.plans_overdue_total / (stats().paymentPlans.plans_created || 1)) *
                100).toFixed(1) }}% Overdue Rate
              </div>
            </div>
          </div>
        </div>
      </div>
      @if(isLoading()){
      <app-individual-toaster></app-individual-toaster>
      }
    </div>
    }

    @case (SectionId.RISK_ASSESSMENT) {
    <div [ngClass]="[sectionCardShellClass(false), getSectionColClass(SectionId.RISK_ASSESSMENT)]">
      <ng-container *ngTemplateOutlet="sectionPin; context: { $implicit: SectionId.RISK_ASSESSMENT }"></ng-container>
      <div class="mb-6">
        <div class="flex items-center gap-3 mb-2">
          <app-icon name="shield" [size]="24" class="text-red-600 dark:text-red-400"></app-icon>
          <h3 class="text-xl font-medium text-[#141437] dark:text-white">Risk Assessment Matrix</h3>
        </div>
        <p class="text-slate-600 dark:text-slate-400">Overdue payments categorized by risk level</p>
      </div>

      <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
        <!-- Low Risk -->
        <div
          class="bg-green-50 dark:bg-green-900/20 border border-green-200 dark:border-green-800 rounded-xl p-4 hover:shadow-lg transition-all duration-300 relative">
          <div class="flex items-center gap-3 mb-3">
            <div class="w-8 h-8 bg-green-500 rounded-full flex items-center justify-center">
              <app-icon name="check" [size]="16" class="text-white"></app-icon>
            </div>
            <div>
              <h4 class="font-medium text-green-800 dark:text-green-300">Low Risk</h4>
              <span class="text-sm text-green-600 dark:text-green-400">&lt; 30 days overdue</span>
            </div>
          </div>
          <div class="text-2xl font-bold text-green-700 dark:text-green-300 mb-3">
            {{ stats().overdue.overdue_less_than_30 || 0 | number }}
          </div>
          <div class="w-full bg-green-200 dark:bg-green-800/50 rounded-full h-2">
            <div class="bg-green-500 h-full rounded-full transition-all duration-700"
              [style.width]="(stats().overdue.overdue_less_than_30 / ((stats().overdue.overdue_less_than_30 || 0) + (stats().overdue.overdue_30_to_60 || 0) + (stats().overdue.overdue_60_to_90 || 0) + (stats().overdue.overdue_90_plus || 0) || 1) * 100) + '%'">
            </div>
          </div>
          @if(isLoading()){
          <app-individual-toaster></app-individual-toaster>
          }
        </div>

        <!-- Medium Risk -->
        <div
          class="bg-yellow-50 dark:bg-yellow-900/20 border border-yellow-200 dark:border-yellow-800 rounded-xl p-4 hover:shadow-lg transition-all duration-300 relative">
          <div class="flex items-center gap-3 mb-3">
            <div class="w-8 h-8 bg-yellow-500 rounded-full flex items-center justify-center">
              <app-icon name="triangleAlert" [size]="16" class="text-white"></app-icon>
            </div>
            <div>
              <h4 class="font-medium text-yellow-800 dark:text-yellow-300">Medium Risk</h4>
              <span class="text-sm text-yellow-600 dark:text-yellow-400">30-60 days overdue</span>
            </div>
          </div>
          <div class="text-2xl font-bold text-yellow-700 dark:text-yellow-300 mb-3">
            {{ stats().overdue.overdue_30_to_60 || 0 | number }}
          </div>
          <div class="w-full bg-yellow-200 dark:bg-yellow-800/50 rounded-full h-2">
            <div class="bg-yellow-500 h-full rounded-full transition-all duration-700"
              [style.width]="(stats().overdue.overdue_30_to_60 / ((stats().overdue.overdue_less_than_30 || 0) + (stats().overdue.overdue_30_to_60 || 0) + (stats().overdue.overdue_60_to_90 || 0) + (stats().overdue.overdue_90_plus || 0) || 1) * 100) + '%'">
            </div>
          </div>
          @if(isLoading()){
          <app-individual-toaster></app-individual-toaster>
          }
        </div>

        <!-- High Risk -->
        <div
          class="bg-orange-50 dark:bg-orange-900/20 border border-orange-200 dark:border-orange-800 rounded-xl p-4 hover:shadow-lg transition-all duration-300 relative">
          <div class="flex items-center gap-3 mb-3">
            <div class="w-8 h-8 bg-orange-500 rounded-full flex items-center justify-center">
              <app-icon name="circleAlert" [size]="16" class="text-white"></app-icon>
            </div>
            <div>
              <h4 class="font-medium text-orange-800 dark:text-orange-300">High Risk</h4>
              <span class="text-sm text-orange-600 dark:text-orange-400">60-90 days overdue</span>
            </div>
          </div>
          <div class="text-2xl font-bold text-orange-700 dark:text-orange-300 mb-3">
            {{ stats().overdue.overdue_60_to_90 || 0 | number }}
          </div>
          <div class="w-full bg-orange-200 dark:bg-orange-800/50 rounded-full h-2">
            <div class="bg-orange-500 h-full rounded-full transition-all duration-700"
              [style.width]="(stats().overdue.overdue_60_to_90 / ((stats().overdue.overdue_less_than_30 || 0) + (stats().overdue.overdue_30_to_60 || 0) + (stats().overdue.overdue_60_to_90 || 0) + (stats().overdue.overdue_90_plus || 0) || 1) * 100) + '%'">
            </div>
          </div>
          @if(isLoading()){
          <app-individual-toaster></app-individual-toaster>
          }
        </div>

        <!-- Critical Risk -->
        <div
          class="bg-red-50 dark:bg-red-900/20 border border-red-200 dark:border-red-800 rounded-xl p-4 hover:shadow-lg transition-all duration-300 relative">
          <div class="flex items-center gap-3 mb-3">
            <div class="w-8 h-8 bg-red-500 rounded-full flex items-center justify-center">
              <app-icon name="x" [size]="16" class="text-white"></app-icon>
            </div>
            <div>
              <h4 class="font-medium text-red-800 dark:text-red-300">Critical Risk</h4>
              <span class="text-sm text-red-600 dark:text-red-400">90+ days overdue</span>
            </div>
          </div>
          <div class="text-2xl font-bold text-red-700 dark:text-red-300 mb-3">
            {{ stats().overdue.overdue_90_plus || 0 | number }}
          </div>
          <div class="w-full bg-red-200 dark:bg-red-800/50 rounded-full h-2">
            <div class="bg-red-500 h-full rounded-full transition-all duration-700"
              [style.width]="(stats().overdue.overdue_90_plus / ((stats().overdue.overdue_less_than_30 || 0) + (stats().overdue.overdue_30_to_60 || 0) + (stats().overdue.overdue_60_to_90 || 0) + (stats().overdue.overdue_90_plus || 0) || 1) * 100) + '%'">
            </div>
          </div>
          @if(isLoading()){
          <app-individual-toaster></app-individual-toaster>
          }
        </div>
      </div>
    </div>
    }

    @case (SectionId.OPERATIONAL_EFFICIENCY) {
    <div [ngClass]="[sectionCardShellClass(false), getSectionColClass(SectionId.OPERATIONAL_EFFICIENCY)]">
      <ng-container
        *ngTemplateOutlet="sectionPin; context: { $implicit: SectionId.OPERATIONAL_EFFICIENCY }"></ng-container>
      <div class="flex items-center gap-3 mb-6">
        <app-icon name="settings" [size]="24" class="text-blue-600 dark:text-blue-400"></app-icon>
        <h4 class="text-xl font-medium text-[#141437] dark:text-white">Operational Efficiency</h4>
      </div>
      <div class="space-y-4">
        <div class="flex justify-between items-center py-3 border-b border-slate-200 dark:border-slate-700">
          <div class="flex items-center gap-2">
            <span class="font-medium text-slate-700 dark:text-slate-300">Request Success Rate</span>
            <app-tooltip position="top"
              content="Formula: Public Requests / Total Requests × 100. Measures how many applications reach the public phase, indicating processing efficiency and application quality."
              variant="info" width="450px" className="!z-[99999] !whitespace-normal !break-words">
              <app-icon name="circleAlert" [size]="12"
                class="text-slate-500 dark:text-slate-400 cursor-help"></app-icon>
            </app-tooltip>
          </div>
          <span class="text-xl font-bold text-green-600 dark:text-green-400">
            {{ ((stats().requests.public_requests / (stats().requests.total_requests || 1)) * 100).toFixed(1) }}%
          </span>
        </div>
        <div class="flex justify-between items-center py-3">
          <div class="flex items-center gap-2">
            <span class="font-medium text-slate-700 dark:text-slate-300">Offer Acceptance Rate</span>
            <app-tooltip position="top"
              content="Formula: Accepted Offers / Total Offers × 100. Shows the conversion rate from loan offers to acceptances, indicating offer competitiveness and market alignment."
              variant="success" className="!max-w-none !w-[500px] !z-[99999] !whitespace-normal !break-words">
              <app-icon name="circleAlert" [size]="12"
                class="text-slate-500 dark:text-slate-400 cursor-help"></app-icon>
            </app-tooltip>
          </div>
          <span class="text-xl font-bold text-green-600 dark:text-green-400">
            {{ ((stats().offers.offers_accepted / (stats().offers.total_offers || 1)) * 100).toFixed(1) }}%
          </span>
        </div>
      </div>
      @if(isLoading()){
      <app-individual-toaster></app-individual-toaster>
      }
    </div>
    }

    @case (SectionId.KEY_PERFORMANCE_METRICS) {
    <div [ngClass]="[sectionCardShellClass(false), getSectionColClass(SectionId.KEY_PERFORMANCE_METRICS)]">
      <ng-container
        *ngTemplateOutlet="sectionPin; context: { $implicit: SectionId.KEY_PERFORMANCE_METRICS }"></ng-container>
      <div class="flex items-center gap-3 mb-6">
        <app-icon name="chartNoAxesCombined" [size]="24" class="text-emerald-600 dark:text-emerald-400"></app-icon>
        <h4 class="text-xl font-medium text-[#141437] dark:text-white">Key Performance Metrics</h4>
      </div>
      <div class="space-y-6">
        <!-- Request Completion Rate -->
        <div
          class="bg-gradient-to-r from-blue-50 to-indigo-50 dark:from-blue-900/20 dark:to-indigo-900/20 rounded-xl p-4 border border-blue-200/50 dark:border-blue-700/50">
          <div class="flex justify-between items-center mb-2">
            <div class="flex items-center gap-2">
              <span class="text-sm font-medium text-blue-700 dark:text-blue-300">Request Fulfillment Rate</span>
              <app-tooltip position="top"
                content="Formula: (Total Requests - Cancelled - Expired) / Total Requests × 100. Shows the percentage of loan applications that are successfully processed (not cancelled or expired). Higher percentage indicates better operational efficiency."
                variant="info" className="!max-w-none !w-[500px] !z-[99999] !whitespace-normal !break-words">
                <app-icon name="circleAlert" [size]="14"
                  class="text-blue-500 dark:text-blue-400 cursor-help"></app-icon>
              </app-tooltip>
            </div>
            <span class="text-lg font-bold text-blue-600 dark:text-blue-400">
              {{ (((stats().requests.total_requests - stats().requests.cancelled_requests -
              stats().requests.expired_requests) / (stats().requests.total_requests || 1)) * 100).toFixed(1) }}%
            </span>
          </div>
          <div class="w-full bg-blue-200 dark:bg-blue-800/50 rounded-full h-2">
            <div class="bg-blue-500 h-full rounded-full transition-all duration-700"
              [style.width]="(((stats().requests.total_requests - stats().requests.cancelled_requests - stats().requests.expired_requests) / (stats().requests.total_requests || 1)) * 100) + '%'">
            </div>
          </div>
        </div>

        <!-- Offer Success Rate -->
        <div
          class="bg-gradient-to-r from-green-50 to-emerald-50 dark:from-green-900/20 dark:to-emerald-900/20 rounded-xl p-4 border border-green-200/50 dark:border-green-700/50">
          <div class="flex justify-between items-center mb-2">
            <div class="flex items-center gap-2">
              <span class="text-sm font-medium text-green-700 dark:text-green-300">Offer Acceptance Rate</span>
              <app-tooltip position="top"
                content="Formula: Accepted Offers / Total Offers × 100. Measures the conversion rate from loan offers to acceptances. Higher percentage indicates better offer attractiveness and market fit."
                variant="success" className="!max-w-none !w-[500px] !z-[99999] !whitespace-normal !break-words">
                <app-icon name="circleAlert" [size]="14"
                  class="text-green-500 dark:text-green-400 cursor-help"></app-icon>
              </app-tooltip>
            </div>
            <span class="text-lg font-bold text-green-600 dark:text-green-400">
              {{ ((stats().offers.offers_accepted / (stats().offers.total_offers || 1)) * 100).toFixed(1) }}%
            </span>
          </div>
          <div class="w-full bg-green-200 dark:bg-green-800/50 rounded-full h-2">
            <div class="bg-green-500 h-full rounded-full transition-all duration-700"
              [style.width]="((stats().offers.offers_accepted / (stats().offers.total_offers || 1)) * 100) + '%'"></div>
          </div>
        </div>

        <!-- Payment Plan Performance -->
        <div
          class="bg-gradient-to-r from-purple-50 to-pink-50 dark:from-purple-900/20 dark:to-pink-900/20 rounded-xl p-4 border border-purple-200/50 dark:border-purple-700/50">
          <div class="flex justify-between items-center mb-2">
            <div class="flex items-center gap-2">
              <span class="text-sm font-medium text-purple-700 dark:text-purple-300">On-Time Payment Rate</span>
              <app-tooltip position="top"
                content="Formula: (Plans Created - Overdue Plans) / Plans Created × 100. Shows the percentage of payment plans that are current (not overdue). Higher percentage indicates good borrower behavior and effective collection processes."
                variant="primary" className="!max-w-none !w-[500px] !z-[99999] !whitespace-normal !break-words">
                <app-icon name="circleAlert" [size]="14"
                  class="text-purple-500 dark:text-purple-400 cursor-help"></app-icon>
              </app-tooltip>
            </div>
            <span class="text-lg font-bold text-purple-600 dark:text-purple-400">
              {{ (((stats().paymentPlans.plans_created - stats().paymentPlans.plans_overdue_total) /
              (stats().paymentPlans.plans_created || 1)) * 100).toFixed(1) }}%
            </span>
          </div>
          <div class="w-full bg-purple-200 dark:bg-purple-800/50 rounded-full h-2">
            <div class="bg-purple-500 h-full rounded-full transition-all duration-700"
              [style.width]="(((stats().paymentPlans.plans_created - stats().paymentPlans.plans_overdue_total) / (stats().paymentPlans.plans_created || 1)) * 100) + '%'">
            </div>
          </div>
        </div>

        <!-- Risk Distribution -->
        <div
          class="bg-gradient-to-r from-amber-50 to-orange-50 dark:from-amber-900/20 dark:to-orange-900/20 rounded-xl p-4 border border-amber-200/50 dark:border-amber-700/50">
          <div class="flex justify-between items-center mb-2">
            <div class="flex items-center gap-2">
              <span class="text-sm font-medium text-amber-700 dark:text-amber-300">Low Risk Portfolio %</span>
              <app-tooltip position="top"
                content="Formula: Overdue < 30 days / Total Overdue × 100. Shows what percentage of overdue accounts are in the safest risk category (less than 30 days overdue). Higher percentage indicates better portfolio quality."
                variant="warning" className="!max-w-none !w-[500px] !z-[99999] !whitespace-normal !break-words">
                <app-icon name="circleAlert" [size]="14"
                  class="text-amber-500 dark:text-amber-400 cursor-help"></app-icon>
              </app-tooltip>
            </div>
            <span class="text-lg font-bold text-amber-600 dark:text-amber-400">
              {{ ((stats().overdue.overdue_less_than_30 / ((stats().overdue.overdue_less_than_30 || 0) +
              (stats().overdue.overdue_30_to_60 || 0) + (stats().overdue.overdue_60_to_90 || 0) +
              (stats().overdue.overdue_90_plus || 0) || 1)) * 100).toFixed(1) }}%
            </span>
          </div>
          <div class="w-full bg-amber-200 dark:bg-amber-800/50 rounded-full h-2">
            <div class="bg-amber-500 h-full rounded-full transition-all duration-700"
              [style.width]="((stats().overdue.overdue_less_than_30 / ((stats().overdue.overdue_less_than_30 || 0) + (stats().overdue.overdue_30_to_60 || 0) + (stats().overdue.overdue_60_to_90 || 0) + (stats().overdue.overdue_90_plus || 0) || 1)) * 100) + '%'">
            </div>
          </div>
        </div>

        <!-- Public vs Private Ratio -->
        <div
          class="bg-gradient-to-r from-cyan-50 to-blue-50 dark:from-cyan-900/20 dark:to-blue-900/20 rounded-xl p-4 border border-cyan-200/50 dark:border-cyan-700/50">
          <div class="flex justify-between items-center mb-2">
            <div class="flex items-center gap-2">
              <span class="text-sm font-medium text-cyan-700 dark:text-cyan-300">Public Request Ratio</span>
              <app-tooltip position="top"
                content="Formula: Public Requests / Total Requests × 100. Shows the percentage of loan applications that are public (vs private). This metric helps understand customer preferences and market transparency trends."
                variant="info" className="!max-w-none !w-[500px] !z-[99999] !whitespace-normal !break-words">
                <app-icon name="circleAlert" [size]="14"
                  class="text-cyan-500 dark:text-cyan-400 cursor-help"></app-icon>
              </app-tooltip>
            </div>
            <span class="text-lg font-bold text-cyan-600 dark:text-cyan-400">
              {{ ((stats().requests.public_requests / (stats().requests.total_requests || 1)) * 100).toFixed(1) }}%
            </span>
          </div>
          <div class="w-full bg-cyan-200 dark:bg-cyan-800/50 rounded-full h-2">
            <div class="bg-cyan-500 h-full rounded-full transition-all duration-700"
              [style.width]="((stats().requests.public_requests / (stats().requests.total_requests || 1)) * 100) + '%'">
            </div>
          </div>
        </div>
      </div>
      @if(isLoading()){
      <app-individual-toaster></app-individual-toaster>
      }
    </div>
    }

    }
    }

  </div>
</div>

<app-dashboard-layout-editor [open]="isLayoutEditorOpen()" [items]="editorItems()" [visibleCount]="editorVisibleCount()"
  [isTallTile]="isLayoutEditorTallTile" (closed)="closeLayoutEditor()" (applied)="applyLayoutEditor()"
  (resetDefaults)="resetLayoutEditorToDefaults()" (cardDropped)="onEditorCardDrop($any($event))"
  (visibilityToggled)="toggleEditorCardVisibility($any($event))"
  (colSpanDecreased)="decreaseEditorCardColSpan($any($event))"
  (colSpanIncreased)="increaseEditorCardColSpan($any($event))" (autoAdjustWidth)="autoAdjustEditorWidths()" />

<!-- </div> -->